<template>
    <div class="ccpay-supplement">
         <div class="ccpay-capital-header">
                <span @click="back"> 退後</span>
                <span >流水明細補充</span>
                <span></span>
         </div>
         <div class="ccpay-capital-connect" >
              <mt-radio
            title="查詢"
             v-model="kindValue"
            :options="options"
            @change="chankindValue"
            >
            </mt-radio>
        </div>
         <div class="ccpay-capital-connect" >
              <mt-loadmore
                v-if="sourceflag"
                :top-method="loadTop"
                :bottom-all-loaded="allLoaded"
                :auto-fill="false"
                ref="loadmore">
              <div class="ccpay-capital-connect-card" v-for="(item,index) in data" :key="index" v-show="item.source=='DEPOSIT'||item.source=='WITHDRAW'">
                  <p class="ccpay-cap-cd-bew" >
                      <span>交易员编号：{{item.userid}} </span>
                      <span >{{getTypeText(item.source)}}</span>
                  </p>
                 
                  <p>訂單编号：{{item.orderNo}}</p>
                   <p>成本價格：{{Formatnumbers(item.ex_price,4,'.',',')}}</p>
                  <p>提現费用：{{Formatnumbers(item.ex_fee,4,'.',',')}}</p>
                  <p >数量：<span style="color:#20ABFE">{{parseFloat(Number(item.value))}}  {{item.symbol}}</span></p>
                 
                  <p>创建時間：<span style="color:#20ABFE">{{item.created_time}}</span></p>
                  <p class="sup-buttton" v-show="!item.ex_id"><button @click="suphanck(item)">補充</button></p>
              </div>
             <Scroll
                v-show="data.length>0"
                @timer="timer"
                :moreTit="bottomText"
                ref="mychild"
            />
               </mt-loadmore>
                <div v-else style="color: #999;text-align: center;">暂时没有数据哦～</div>
         </div>
        
    </div>
</template>

<script>
import Scroll from "@/component/scroll";
import {setCookie,setElpCookie,ccpayUser,getCookie,Formatnumbers} from '../../public/index.js'
import { Indicator } from 'mint-ui';
export default {
    components:{
        Scroll
    },
    data(){
        return {
            data:[],
            allLoaded:false,
            topStatus:'',
            curPage:1,
            bottomText:'上拉加载更多...',
            sourceflag:false,
            value:false,
            kindValue:'DEPOSIT',
            options:[
                {
                    label: '充值',
                    value: 'DEPOSIT'
                },
                {
                    label: '提現',
                    value: 'WITHDRAW'
                }]
        }
    },
    mounted(){
        this.getdata()
    },
    methods:{
        Formatnumbers,
        chankindValue(){
            this.getdata()
            // console.log(this.kindValue)
        },
        suphanck(item){
          this.$router.push({
            path:'/supmetdetail',
            query:{
                fund_id:item.id,
             }
          })
        },
        back(){
            this.$router.go(-1)
        },
        getdata(){
             Indicator.open();
            this.$axios.get(`/v1/account/amount/history?page=1&per_page=10&sortby=id&order=0&type=-1&symbol=USDT&source=${this.kindValue}`)
            .then(res=>{
                 Indicator.close();
                if(res.code==0){
                this.data = res.data
                this.curPage=1
                this.data.forEach((item,index)=>{
                    if(item.source=='DEPOSIT'||item.source=='WITHDRAW'){
                        this.sourceflag = true
                    }   
                })
                // console.log(res.data)
                }
            })
        },
        timer(){
            
            this.bottomText= '正在加载...'
            this.onPullingUp()
        },
        onPullingUp(){  
             this.curPage++
             this.$axios.get(`/v1/account/amount/history?page=${this.curPage}&per_page=10&sortby=id&order=0&type=-1&symbol=USDT&source=${this.kindValue}`)
            .then(res=>{
                if(res.code==0){
                     let data = res.data
                    if(data.length==0){
                        this.bottomText= '暂时没有了'
                        this.$refs.mychild.gets();
                   }else{
                       this.bottomText= '加载更多'
                       this.data = this.data.concat(res.data);
                       this.$refs.mychild.get();
                   }
                    // this.data = res.data
                    // console.log(res)
                }
            })
        },
        loadTop(){
            setTimeout(()=>{
                  this.getdata()
                  this.$refs.loadmore.onTopLoaded();
                  this.bottomText= '加载更多'
                  this.$refs.mychild.get();
            },1000)
        },
        getTypeText(source) {
            switch (source) {
              case "PROFIT":
                return "利润";
              case "BUY":
                return "购买";
              case "SELL":
                return "出售";
              case "DEPOSIT":
                return "充值";
              case "WITHDRAW":
                return "提現";
              case "WITHDRAW_FEE_OUT":
                return "提現手续费";
              case "ROLLBACK":
                return "拒绝退回";
              default:
                return source;
      }
    },
       
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-supplement{
        
         min-height: 100%;
         background: #f8f8f8;
         .ccpay-capital-header{ 
                height: 3rem;
                line-height: 3rem;
                width: 100%;
                position: fixed;
                background: white;
                display: flex;
                justify-content: space-between;
                span:nth-of-type(1){
                    margin-left: 1rem
                }
                span:nth-of-type(3){
                    margin-right: 1rem
                }
         }
         .ccpay-capital-connect{
             padding-top: 4rem;
             padding-left:1rem;
             padding-right:1rem;
             .ccpay-capital-connect-card{
                 padding:1rem;
                 margin-bottom: 2rem;
                 p{
                     line-height: 1.8rem;
                    
                 }
                  .sup-buttton{
                      text-align: right;
                      margin-top: 1rem;
                      button{
                        color: white;
                        background: #C4A576;
                        /* opacity: 0.2; */
                        border: navajowhite;
                        padding: 0.4rem;
                        padding-left: 1.6rem;
                        padding-right: 1.6rem;
                        border-radius: 5px;
                        margin-right: 1rem;
                        outline: none;
                      }
                     }
                 .ccpay-cap-cd-bew{
                    display: flex;
                    justify-content: space-between;
                     span:nth-of-type(2){
                         color: red;
                     }
                 }
             }
             .ccpay-capital-connect-card:nth-child(odd){
                 background: white;
             } 
             .ccpay-capital-connect-card:nth-child(even){
                 background: #eee;
             } 
             .ccpay-capital-connect-card:hover{
                  background: #eee;
             }
         }
    }
</style>



// WEBPACK FOOTER //
// src/components/my/supplement.vue